export const activeOperatorsSelector = state => ({
    activeOperators: state.adminReducer.activeOperators,
    activeOperatorLoadedTime: state.adminReducer.activeOperatorLoadedTime,
    configKeys: state.adminReducer.configKeys
});
export const selectedOperatorSelector = state =>state.adminReducer.selectedOperator;
